import {
  HomeIcon,
  CubeIcon,
  TagIcon,
  TicketIcon,
  UsersIcon,
  ShoppingBagIcon,
  ShieldCheckIcon,
  TruckIcon,
  ChatBubbleLeftRightIcon,
} from '@heroicons/react/24/outline';
import type { ComponentType, SVGProps } from 'react';

export interface NavItem {
  label: string;
  to: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  /** Match only the exact path (used for "/" so it doesn't stay active everywhere) */
  end?: boolean;
}

export interface NavGroup {
  label?: string;
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    items: [{ label: 'Dashboard', to: '/', icon: HomeIcon, end: true }],
  },
  {
    label: 'Catalog',
    items: [
      { label: 'Products', to: '/products', icon: CubeIcon },
      { label: 'Categories', to: '/categories', icon: TagIcon },
      { label: 'Promotions', to: '/promotions', icon: TicketIcon },
    ],
  },
  {
    label: 'Sales',
    items: [
      { label: 'Orders', to: '/orders', icon: ShoppingBagIcon },
      { label: 'Users', to: '/users', icon: UsersIcon },
    ],
  },
  {
    label: 'Administration',
    items: [
      { label: 'Admin Users', to: '/admin-users', icon: ShieldCheckIcon },
      { label: 'Shipping', to: '/shipping-settings', icon: TruckIcon },
      { label: 'Instagram', to: '/instagram', icon: ChatBubbleLeftRightIcon },
    ],
  },
];

export const FLAT_NAV_ITEMS: NavItem[] = NAV_GROUPS.flatMap((group) => group.items);
